import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getAwailableReportsAddress = async () => {
  return await request.get(
    `/HousingStock/report/address/awailable`,
    {},
    'При загрузке информации о доступных отчетах произошла ошибка',
    []
  );
};

const useAwailableReportsAddress = (options = {}) =>
  useQuery(
    getQueryKeys.awailableReportsAddress(),
    () => getAwailableReportsAddress(),
    options
  );

export default useAwailableReportsAddress;
